/**
 * Normalize a lat/lng pair for map use.
 * - Rejects missing / non-finite values
 * - Rejects (0, 0) null-island placeholders
 * - Fixes clearly swapped pairs (e.g. longitude in the lat slot)
 */
export function normalizeLatLng(
  rawLat: unknown,
  rawLng: unknown,
): { lat: number; lng: number } | null {
  const a = typeof rawLat === 'number' ? rawLat : rawLat == null || rawLat === '' ? NaN : Number(rawLat)
  const b = typeof rawLng === 'number' ? rawLng : rawLng == null || rawLng === '' ? NaN : Number(rawLng)
  if (!Number.isFinite(a) || !Number.isFinite(b)) return null
  if (a === 0 && b === 0) return null

  // Standard order: lat, lng
  if (Math.abs(a) <= 90 && Math.abs(b) <= 180) {
    return { lat: a, lng: b }
  }

  // Swapped order: lng, lat (common when GeoJSON-style pairs are mis-assigned)
  if (Math.abs(b) <= 90 && Math.abs(a) <= 180) {
    return { lat: b, lng: a }
  }

  return null
}

export function toCoord(value: unknown): number | null {
  if (value == null || value === '') return null
  const n = Number(value)
  return Number.isFinite(n) ? n : null
}
